import { z } from '@/utils/zod'

export const createCurrencySchema = ({
    canBeNegative,
    canBeZero,
    max = 99999999_99,
}: {
    canBeNegative: boolean
    canBeZero: boolean
    max?: number
}) => {
    if (canBeNegative && canBeZero) {
        return z.number().int().max(max)
    } else if (canBeNegative) {
        return z.number().int().positive().max(max).or(z.number().int().negative().max(max))
    } else if (canBeZero) {
        return z.number().int().nonnegative().max(max)
    } else {
        return z.number().int().positive().max(max)
    }
}
